import { ICheckPublishTermSchema } from '../../../../../repositories/monolith-python/entities/CheckPublishTermSchema';
import { IPublishTermsSchema } from '../../../../../repositories/monolith-python/entities/offer/PublishTermsSchema';
import { EServiceType } from '../../../../reducers';

interface IParams {
  isAutoprolongAvailable: boolean;
  isAutoprolongChecked: boolean;
  terms: Array<ICheckPublishTermSchema>;
}

export const mapPublishTerms = (params: IParams): IPublishTermsSchema | null => {
  const { isAutoprolongAvailable, isAutoprolongChecked, terms } = params;

  if (!Array.isArray(terms)) {
    return null;
  }

  const publishTerms = {
    terms,
    autoprolong: isAutoprolongChecked,
    usePromotionFromAuction: false,
  } as unknown as IPublishTermsSchema;

  const isDailyTermSelected = terms.some(({ type, services }) => {
    return type === 'dailyTermless' && !services.includes(EServiceType.auction);
  });

  // Для посуточной оплаты всегда ставим автопролонгацию, за исключением аукциона
  if (isAutoprolongAvailable && isDailyTermSelected) {
    publishTerms.autoprolong = true;
  }

  return publishTerms;
};
